<template>
  <BaseCard
    class="dreamChart"
    padding="none"
  >
    <BaseCardHeader>
      <h3>{{ isShowAbout ? l('dreamPage.about.title') : l('dreamPage.chart.title') }}</h3>

      <BaseIcon
        :icon="isShowAbout ? 'cross' : 'info'"
        @click="isShowAbout = !isShowAbout"
      />
    </BaseCardHeader>
    <BaseCardHeader
      v-show="!isShowAbout"
      class="flex md:hidden"
    >
      <div class="subtitle">
        {{ l('destinationPage.spiderChart.description.short') }}
      </div>
    </BaseCardHeader>

    <div
      v-show="!isShowAbout"
      class="dreamChart__chartContainer"
    >
      <BaseChartRadar
        :chart-data="chartDataRadar"
        :options="chartOptionsRadar"
        :is-mutable="true"
        :draggable-indexes="[0]"
        @on-drag-end="onDragEnd"
      />
    </div>
    <DestinationPickerChartInfo v-show="isShowAbout" />
    <div
      v-show="!isShowAbout"
      class="flex flex-wrap flex-row justify-evenly buttons"
    >
      <BaseButton
        size="small"
        white-blue
        @click="setMin"
      >
        Min
      </BaseButton>
      <BaseButton
        size="small"
        white-blue
        @click="setMax"
      >
        Max
      </BaseButton>
      <BaseButton
        size="small"
        white-blue
        @click="setUserPreferenceRandom"
      >
        {{ l('global.simplePhrases.random') }}
      </BaseButton>
    </div>
  </BaseCard>
</template>

<script setup>
import { l } from '@utils/toolbox';
import useRadarChartOptions from '@/src/vue/utils/useRadarChartOptions';
import BaseChartRadar from '../Base/BaseChartRadar.vue';
import BaseCard from '../Base/BaseCard.vue';
import BaseCardHeader from '../Base/BaseCardHeader.vue';


const props = defineProps({
	chartData: {
		type: Object,
		required: true
	}
});
const emit = defineEmits(['update:chartData']);
// Setup
const isShowAbout = ref(false);

// Chart options
const chartOptionsRadar = useRadarChartOptions();

// Chart data
const chartDataRadar = computed(() => {
	return {
		labels: [
			l('destinationPage.spiderChart.points.environment.label'),
			l('destinationPage.spiderChart.points.safety.label'),
			l('destinationPage.spiderChart.points.freedom.label'),
			l('destinationPage.spiderChart.points.guaranteed_sunshine.label'),
			l('destinationPage.spiderChart.points.corruption.label'),
			l('destinationPage.spiderChart.points.internet_connection.label'),
			l('destinationPage.spiderChart.points.cost_of_living.label'),
			l('destinationPage.spiderChart.points.language_barriers.label')
		],
		datasets: [
			{
				label: '',
				data: props.chartData,
				fill: false,
				borderColor: 'rgba(49,82,122, 0.8)',
				borderWidth: 3,
				pointBorderColor: 'rgba(251,204,44, 1)',
				pointBackgroundColor: 'white',
				backgroundColor: 'rgba(46, 91, 139, .21)',
				radius: 6,
				hoverRadius: 6,
				hoverColor: 'rgba(251,204,44, 1)',
				hoverBackgroundColor: 'white',
				hoverBorderWidth: 3
			}
			// {
			//   label: '',
			//   // borderColor: 'rgb(0, 0, 137, 0.5)',
			//   borderWidth: 2,
			//   // backgroundColor: 'rgba(0, 0, 137, 0.5)',
			//   radius: 0,
			//   hoverRadius: 0,
			//   hoverBorderWidth: 0,
			//   fill: true,
			//   backgroundColor: 'white',
			//   data: props.item
			//     ? [
			//         Math.min(100, props.item.environmental_performance),
			//         Math.min(100, props.item.safety),
			//         Math.min(100, props.item.freedom),
			//         Math.min(100, props.item.guaranteed_sunshine),
			//         Math.min(100, props.item.corruption),
			//         Math.min(100, props.item.internet_connection),
			//         Math.min(100, props.item.cost_of_living),
			//         Math.min(100, props.item.language_barriers)
			//       ]
			//     : randomArray()
			// }
		]
	};
});

// Click events
function setUserPreferenceRandom () {
	const shapes1 = [[100, 50, 100, 50, 100, 50, 100, 50], [50, 100, 50, 0, 50, 100, 50, 0], [100, 50, 100, 50, 100, 50, 100, 50], [0, 10, 20, 30, 40, 50, 60, 70], [0, 50, 100, 50, 0, 50, 100, 50], [100, 0, 50, 0, 100, 0, 50, 0], [100, 0, 100, 0, 100, 0, 100, 0], [100, 0, 0, 100, 0, 0, 100, 0], [100, 20, 20, 20, 20, 20, 20, 20], [100, 100, 20, 20, 100, 100, 20, 20], [100, 80, 60, 40, 20, 40, 60, 80], [100, 0, 100, 0, 100, 0, 100, 0], [0, 20, 40, 60, 80, 60, 40, 20], [80, 60, 40, 20, 0, 20, 40, 60], [100, 100, 100, 20, 20, 20, 100, 100], [20, 20, 20, 100, 100, 100, 20, 20], [100, 20, 100, 20, 100, 20, 100, 20], [20, 100, 20, 100, 20, 100, 20, 100], [50, 70, 90, 70, 50, 30, 10, 30], [10, 10, 30, 30, 50, 50, 70, 70], [70, 70, 50, 50, 30, 30, 10, 10], [10, 30, 50, 70, 90, 70, 50, 30], [90, 70, 50, 30, 10, 30, 50, 70], [20, 80, 20, 80, 20, 80, 20, 80], [10, 20, 30, 40, 50, 60, 70, 80], [80, 70, 60, 50, 40, 30, 20, 10], [20, 100, 20, 20, 20, 100, 20, 20], [80, 0, 80, 80, 80, 0, 80, 80], [10, 40, 70, 100, 70, 40, 10, 10], [100, 100, 100, 100, 100, 100, 100, 100], [10, 10, 10, 10, 10, 10, 10, 10], [90, 10, 90, 10, 90, 10, 90, 10]];
	const shapes2 = Array.from({ length: 100 - shapes1.length }, () => randomArray());
	const shapes3 = Array.from({ length: 2 }, () => getMagic());
	const shapes = [...shapes1, ...shapes2, ...shapes3];
	const shape = rotate(shapes[Math.floor(Math.random() * shapes.length)]);
	emit('update:chartData', shape);
}

function setMax () {
	emit('update:chartData', [100, 100, 100, 100, 100, 100, 100, 100]);
}

function rotate (arr) {
	const rotate = Math.floor(Math.random() * arr.length);
	const rotated = arr.slice(rotate).concat(arr.slice(0, rotate));
	return rotated;
}

function getMagic () {
	const goldenRatio = 1.61803398875;
	const length = 8;

	let lastVal = 100;

	const magic = Array.from({ length }, (_, i) => {
		if (i === 0) {
			return 100;
		} // the first element is 100
		lastVal = lastVal / goldenRatio;
		return Number.parseFloat(lastVal.toFixed(2));
	});

	return rotate(magic);
}

function setMin () {
	emit('update:chartData', [0, 0, 0, 0, 0, 0, 0, 0]);
}

// Dragging
function onDragEnd (chartData) {
	console.log('Drag Ended', chartData);
	emit('update:chartData', chartData.datasets[0].data);
}

function randomArray () {
	return Array.from({ length: 8 }, () => Math.floor(Math.random() * 100) + 1).sort(() => Math.random() - 0.5);
}
</script>

<style scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0 3rem 0 0;
}

.dreamChart{
  overflow: hidden;
  background-color: #fff;
}

.dreamChart__chartContainer{
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 0 .6rem;
}

/* text-gray text-[1.1rem] */
.subtitle {
  color: #6e6e6e;
  font-size: 1.1rem;
}

.buttons {
  margin-bottom: 1rem;
}
</style>
